import { ValidationState } from '../../WebGiving/validation/view-model-validator';
import { observable, action } from 'mobx';
import { PayerOnboardingPage } from './index';
import { PayerOnboardingError } from '../components/error-message/payer-onboarding-error';

export interface UserActionState {
	blocked?: boolean;
}

export interface IPayerOnboardingPageViewModel {
	validationState?: ValidationState;
	readonly type: PayerOnboardingPage;
	isLoading: boolean;
	isBlocked: boolean;
	error?: PayerOnboardingError;
	pageShouldBeVisible: boolean;
	userActionState: UserActionState;
	validate(): ValidationState;
	setPageShouldBeVisible(): void;
	blockUserActions(): void;
}

export abstract class PayerOnboardingPageViewModelBase implements IPayerOnboardingPageViewModel {
	abstract type: PayerOnboardingPage;

	@observable
	validationState?: ValidationState;

	@observable
	isLoading: boolean = false;

	@observable
	isBlocked: boolean = false;

	@observable
	error?: PayerOnboardingError;

	@observable
	pageShouldBeVisible: boolean;

	@observable
	userActionState = { blocked: false };

	abstract validate(): ValidationState;

	@action.bound
	setPageShouldBeVisible() {
		this.pageShouldBeVisible = true;
	}

	@action.bound
	blockUserActions(): void {
		this.userActionState.blocked = true;
	}
}
